import {
  updateLabelConfig,
  invoiceNumberErrorMessageSelector,
} from '../../../data/labelInfos/index.js'
import {useSelector} from '../../../store.js'
import {
  CANADA_POST,
  FEDEX,
  FEDEX_360,
  SHIPPO,
  USPS_SHIP,
} from '../../../common/constants/ShipperNames.js'
import ConfigTextInput from './ConfigTextInput.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {
  defaultValidLabelPropertiesFunc,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
} from './useLabelProperty.js'

const LABEL_PROPERTY = 'invoice_number'
const VALID_SHIPPER_TYPES = [CANADA_POST, FEDEX, FEDEX_360, SHIPPO, USPS_SHIP]

export default function InvoiceNumber() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = InvoiceNumber.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const error = useSelector((state) =>
    invoiceNumberErrorMessageSelector(state, {labelInfoID, shipperType}),
  )

  return (
    <ConfigTextInput
      label="Invoice Number"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {[labelProperty]: value})

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      errorMessage={error}
    />
  )
}

InvoiceNumber.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
